// VideoRequirementsModal.js
import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

const VideoRequirementsModal = ({ isOpen, toggle }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
        <ModalHeader className="d-flex justify-content-between align-items-center w-full video-event-header">
            <span>Video requirements</span>
            <FontAwesomeIcon
            icon={faXmark}
            className="cursor-pointer"
            onClick={toggle}
            style={{ fontSize: '1.2rem' }}
            />
        </ModalHeader>
      <ModalBody>
        <h3 className="fw-bold">Recommendations</h3>
        <ul style={{listStyleType: "disc"}} className='px-2'>
          <li className='my-2'>Show off your event’s vibe with shots of your venue, the atmosphere, and other attendees.</li>
          <li>Include highlights of your event to give attendees a better sense of what to expect.</li>
          <li className='my-2'>Avoid using text.</li>
        </ul>

        <h3 className="fw-bold mt-4">Technical requirements</h3>
        <ul style={{listStyleType: "disc"}} className='px-2'>
          <li className='my-2'>Min resolution: <strong>480p</strong> </li>
          <li>Ratio: any <strong>vertical</strong></li>
          <li className='my-2'>Length: up to <strong>1 min</strong></li>
          <li>Formats: <span className="badge bg-light text-dark border me-2">MP4</span><span className="badge bg-light text-dark border me-2">MOV</span></li>
          <li className='my-2'>Codecs: MPEG-4 Part 2, AVC (H.264)</li>
          <li>Audio: AAC</li>
        </ul>
      </ModalBody>
    </Modal>
  );
};

export default VideoRequirementsModal;
